import { Box, Stack } from "@mui/material";
import React from "react";
import { Color, FontStyle, JobDisplays } from "../constants";

const styles = {
  container: {
    zIndex: 1,
    width: "100%",
    minWidth: "",
    ...FontStyle.body,
    borderRadius: JobDisplays.borderRadius,
    backgroundColor: JobDisplays.backgroundColor,
    boxShadow: JobDisplays.boxShadow,
    // padding: JobDisplays.padding,
    cursor: "pointer",
    // transition: 'all 0.3s ease-in-out',
  },
  panel: {
    color: "#888",
    "&:hover": {
      backgroundColor: "#ddd",
    },
    width: "100%",
    textAlign: "center",
    py: "10px",
    borderRadius: JobDisplays.borderRadius,
    transition: "all 0.2s ease-in-out",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  selectedPanel: {
    // color: '#fff',
    color: "#000",
    // backgroundColor: '#000',
    backgroundColor: Color.primary,
    "&:hover": {},
  },
};

const sortTypes = ["Profile", "Security"];

const SettingsSort = ({ idx, setIdx }) => {
  return (
    <Stack direction="row" sx={styles.container}>
      {sortTypes.map((sortType, i) => (
        <Box
          key={i}
          sx={{ ...styles.panel, ...(idx === i && styles.selectedPanel) }}
          onClick={() => {
            setIdx(i);
          }}>
          {sortType}
        </Box>
      ))}
    </Stack>
  );
};

export default SettingsSort;
